<template>
  <div
    class="app-input"
    :class="[
      {
        'validation-error': hasValidationError,
        withIcon: withIcon,
        focusable: isFocused,
        'with-value': modelValue,
      },
      classList,
    ]"
  >
    <label
      v-if="labelText"
      :for="name"
      class="app-input__label"
      :class="{ focusable: isFocused, 'with-value': modelValue }"
      >{{ labelText }}</label
    >
    <div class="app-input-container">
      <label
        :for="name"
        class="app-input__left"
        :class="{ focusable: isFocused }"
        ><slot name="icon"></slot
      ></label>
      <input
        v-if="type !== 'textarea'"
        :id="name"
        :name="name"
        :type="inputType"
        :value="modelValue"
        v-bind="$attrs"
        @keydown.space="handleSpace"
        @focus="handleFocus"
        @blur="handleBlur"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <textarea
        v-if="type === 'textarea'"
        :id="name"
        :value="modelValue"
        v-bind="$attrs"
        @input="$emit('update:modelValue', $event.target.value)"
      >
      </textarea>
      <a
        v-if="type === 'password'"
        class="app-input__reveal"
        @click.prevent="togglePasswordVisibility"
      >
        <eye-icon></eye-icon>
      </a>
    </div>
  </div>
</template>

<script>
import EyeIcon from '@/assets/svg/eye.svg?component'

export default {
  name: 'AppInput',
  components: {
    EyeIcon,
  },
  props: {
    name: {
      required: true,
      type: String,
    },
    icon: {
      required: false,
      type: String,
      default: '',
    },
    type: {
      required: false,
      type: String,
      default: 'text',
    },
    modelValue: {
      required: false,
      type: String,
      default: '',
    },
    validationModel: {
      required: false,
      type: Object,
      default: () => {},
    },
    labelText: {
      type: String,
      default: null,
    },
    defaultValue: {
      type: String,
      default: '',
    },
    preventSpacing: {
      type: Boolean,
      default: false,
    },
    withIcon: {
      type: Boolean,
      default: false,
    },
    theme: {
      required: false,
      type: String,
      // default: 'white',
    },
  },
  data() {
    return {
      passwordRevealed: false,
      isFocused: false,
      themes: {
        default: 'default',
        white: 'theme-white',
      },
    }
  },
  computed: {
    inputType() {
      return this.passwordRevealed ? 'text' : this.type
    },
    hasValidationError() {
      return this.validationModel && this.validationModel.$error
    },
    classList() {
      return this.themes[this.theme]
    },
  },
  mounted() {
    if (this.defaultValue) {
      this.$emit('update:modelValue', this.defaultValue)
    }
  },
  methods: {
    handleSpace(event) {
      if (this.preventSpacing) {
        event.preventDefault()
      }
    },
    togglePasswordVisibility() {
      this.passwordRevealed = !this.passwordRevealed
    },
    handleFocus() {
      this.isFocused = true
      // const parentNode = el.target.parentNode
      // const label = parentNode.querySelector('label')
      // label.classList.add('focusable')
    },
    handleBlur() {
      this.isFocused = false
      // console.log(this.value)
      // const parentNode = el.target.parentNode
      // const label = parentNode.querySelector('label')
    },
  },
}
</script>
